module.exports = __webpack_public_path__ + "static/media/js.7e1d197c.png";